export const enum GameThumbnailInteractionStatus {
	Favorite = "Favourite",
	UnFavorite = "Un-Favourite",
}

export interface GameThumbnailOptions {
	showJackpot?: boolean;
	maxTagsCount?: number;
	canOpenGameLauncher?: boolean;
	showOpenClosed?: boolean;
	showBetLimits?: boolean;
	showBetBehind?: boolean;
	showAvailableSeats?: boolean;
	showRouletteResults?: boolean;
	showThumbnailOverlay?: boolean;
}

export type GameThumbnailUrls = {
	[key in GameThumbnailUrlsProps]: string | undefined;
};

export enum GameThumbnailUrlsProps {
	baseUrl = "baseUrl",
	loginUrl = "loginUrl",
	loginAndPlayUrl = "loginAndPlayUrl",
	practicePlayUrl = "practicePlayUrl",
	returnUrl = "returnUrl",
	returnLoginUrl = "returnLoginUrl",
}

export interface QueryParams {
	action?: string | unknown;
	gameAction?: string;
	returnUrl?: string;
}

export interface GenericQueryParams {
	[key: string]: string | string[] | undefined;
}

export interface GameThumbnailUrlParameters {
	queryParams: QueryParams;
	useLoginRoute?: boolean;
}

export enum TrackingType {
	playForReal = "playForReal",
	playForFun = "playForFun",
}

export interface ThumbnailClickData {
	urlType: GameThumbnailUrlsProps;
	trackingType?: TrackingType;
}

export const enum GameThumbnailInteractionMode {
	None = "",
	Play = "Play",
	Select = "Select",
	CustomAction = "CustomAction",
}
